import React, { useCallback, useEffect, useState } from "react";
// import { data } from './mockData';

function App() {
  // let res = [];
  const [res, setRes] = useState([]);

  return (
    <>
      <div className="mr-[110px] relative flex items-center">
        <div className=" -z-10 p-3 w-96 h-60 text-green-700 font-semibold">
          {/* {comments} */}
        </div>
      </div>
    </>
  );
}

export default App;
